interface TouchProps {
  force?: number;
  radiusX?: number;
  radiusY?: number;
}

let lastTouchProps: TouchProps | undefined;

if (typeof window !== 'undefined') {
  window.addEventListener(
    'touchstart',
    (e) => {
      const t = e.touches[0] || e.changedTouches[0];
      if (!t) return;
      lastTouchProps = {
        force: typeof t.force === 'number' ? Number(t.force.toFixed(4)) : undefined,
        radiusX:
          typeof (t as Touch & { radiusX?: number }).radiusX === 'number'
            ? Number((t as Touch & { radiusX?: number }).radiusX!.toFixed(2))
            : undefined,
        radiusY:
          typeof (t as Touch & { radiusY?: number }).radiusY === 'number'
            ? Number((t as Touch & { radiusY?: number }).radiusY!.toFixed(2))
            : undefined,
      };
    },
    { passive: true },
  );
}

export function getLastTouchProps(): TouchProps | undefined {
  return lastTouchProps;
}
